import { useState, useEffect } from 'react';
import { useDecision } from '@optimizely/react-sdk';

type ReturnVariables = {
  tooltip?: string;
  campaign_message?: string;
  disclaimer?: string;
};

interface Result {
  isReady: boolean;
  isPointsRedemptionStrikethrough: boolean;
  tooltipMessage?: string;
  campaignMessage?: string;
  disclaimer?: string;
}

const FEATURE_FLAG_NAME = 'qantas-hotels-points-redemption-strikethrough';

const usePointsRedemptionStrikethrough = (): Result => {
  const [decision, isReady] = useDecision(FEATURE_FLAG_NAME, {
    autoUpdate: true,
  });

  const [returnVariables, setReturnVariables] = useState<ReturnVariables>({});
  const [isPointsRedemptionStrikethrough, setIsPointsRedemptionStrikethrough] = useState(false);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    setIsPointsRedemptionStrikethrough(decision.enabled);

    if (decision.enabled) {
      setReturnVariables(decision.variables as ReturnVariables);
    }
  }, [decision, isReady]);

  return {
    isReady,
    isPointsRedemptionStrikethrough,
    tooltipMessage: returnVariables.tooltip,
    campaignMessage: returnVariables.campaign_message,
    disclaimer: returnVariables.disclaimer,
  };
};

export default usePointsRedemptionStrikethrough;
